module.exports = __webpack_public_path__ + "img/tableros_de_distribucion.6ef19af9.jpg";